import { render, staticRenderFns } from "./sprintOverview.vue?vue&type=template&id=8d6f8262&scoped=true&"
import script from "./sprintOverview.vue?vue&type=script&lang=js&"
export * from "./sprintOverview.vue?vue&type=script&lang=js&"
import style0 from "./sprintOverview.vue?vue&type=style&index=0&id=8d6f8262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6f8262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6f8262')) {
      api.createRecord('8d6f8262', component.options)
    } else {
      api.reload('8d6f8262', component.options)
    }
    module.hot.accept("./sprintOverview.vue?vue&type=template&id=8d6f8262&scoped=true&", function () {
      api.rerender('8d6f8262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/ProjectManager/sprintOverview.vue"
export default component.exports